import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { DynamicsCrmLinkedService } from 'app/model/linkedservice/dynamics-crm.linkedservice';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { IModel } from 'app/model/base/annotation';
import { GlobalVariables } from 'app/services/globals';
import { dynamicsLSProperties, dynamicsPropertiesToModelAsync, dynamicsPropertiesToResourceAsync } from './dynamics-linkedservice.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DynamicsCrmLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: dynamicsLSProperties
    }
})
export class DynamicsCrmLinkedServiceAdapter extends LinkedServiceAdapter<DynamicsCrmLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => DynamicsCrmLinkedService {
        return DynamicsCrmLinkedService;
    }

    protected model(): IModel {
        return DynamicsCrmLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: DynamicsCrmLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.DynamicsCRMLinkedService;
        properties.type = Metamodel.modelFor(DynamicsCrmLinkedService).name;
        return dynamicsPropertiesToResourceAsync(linkedService, properties, linkedServiceResource, GlobalVariables.enableConnectorUserAuthCred, this.context, this.valueToResource.bind(this));
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: DynamicsCrmLinkedService): Promise<DynamicsCrmLinkedService> {
        const properties = linkedServiceResource.properties as Model.DynamicsCRMLinkedService;
        const typeProperties: Model.DynamicsCRMLinkedServiceTypeProperties = properties.typeProperties;
        return dynamicsPropertiesToModelAsync(typeProperties, linkedService, this.context);
    }
}
